import React from 'react';
import '../../../styles/Header.scss';
// import logo from '../../../assets/clinical-visuals-logo-Black.png';  // old logo
// import logo from '../../../assets/clinical-visuals-logo-white.png';
import entLogo from '../../../assets/ENT centre logo 2.png';
import { Box,
    useMediaQuery } from '@mui/material';
import { 
  // Link, 
  useLocation } from 'react-router-dom';
import AppButton from '../button';
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;  
const HeaderUtah: React.FC = () => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const location = useLocation();
  const isEntPage = location.pathname === '/ent';
  const isligerPage = location.pathname === '/liger';
  

  return (
    <header
      className={`headermain ${isEntPage ? "entLogoHeader" : isligerPage ? "ligerLogoHeader" : ""}`}
      style={{ padding: "5px 5px" }}
    >
      {!isEntPage && (
        <a href="/" style={{ display: "contents" }}>
          <img
            style={{
              width: "12%",
              display: "block",
              marginLeft: 0,
              marginRight: "auto",
            }}
            className={isMobile ? "imageLogoMobile" : "imageLogo"}
            src={`${VISUALIZE__URL}Clinical_Visuals_Logo.webp`}
            alt="headerlogo"
          />
        </a>
      )}
      {/* {!isEntPage && !isligerPage && (
        <img className={isMobile ? 'imageLogoMobile' : 'imageLogo'} src={logo} alt="headerlogo" />
      )} */}
      {isEntPage && (
        <Box
          component="img"
          src={entLogo}
          alt="Clinical Visuals"
          height={{ md: 150, xs: 100, sm: 100 }}
          width={{ md: 96, xs: 100, sm: 100 }}
          sx={{
            // height: 150,
            // width: 96,
            marginLeft: 2,
            marginTop: "4px",
            marginBottom: "4px",
            "@media (max-width: 600px)": {
              // width: 100,
              // height: 100,
            },
          }}
        />
      )}
      {/* {isligerPage && (
        <Box
          sx={{
            height: 150,
            width: 96,
            marginLeft: 2,
            marginTop: '4px',
            marginBottom: '4px',
            '@media (max-width: 600px)': {
              width: 100,
              height: 100,
            },
          }}
          component="img"
          src={ligerLogo}  // Add your liger logo here
          alt="liger logo"
        />
      )} */}
      {/* <Link href={DownloadPDF} download
                  className="down_link"
                  
                  // download={DownloadPDF} 
                >
                  <IconButton  className="down_pdf"
                      sx={{ position: 'absolute', right: '0', marginRight: '50px', backgroundColor:'#039ad1', borderRadius:'5px', color:'#fff', border:'1px solid #3ccafd' }}
                      aria-label="Download PDF"
                    >
                    <FileDownloadOutlinedIcon sx={{ marginRight: 1 }} />
                    {!isMobile && (
                      <Typography variant="body2" className="down_title">
                        Download PDF
                      </Typography>
                    )}
                  </IconButton>
                </Link> */}
      {isligerPage && (
        <Box>
          <AppButton
            text="Liger iris system storyboard"
            className="down_btn"
            sx={{
              mr: 1,
              backgroundColor: "#039ad1",
              // display: { xs: 'none', md: 'flex' },
              fontFamily: "monospace",
              color: "inherit",
              textDecoration: "none",
              textTransform: "capitalize",
              letterSpacing: "2px",
              border: "2px solid #fff",
              borderRadius: "30px",
              fontWeight: "500",
            }}
            onClick={() => {}}
            href="https://clinicalvisuals.s3.amazonaws.com/medical/liger/pdf/liger_iris_system.pdf"
            download
          />

          <AppButton
            text=" Iris final script and Animation plan"
            className="down_btn"
            sx={{
              mr: 1,
              backgroundColor: "#039ad1",
              // display: { xs: 'none', md: 'flex' },
              fontFamily: "monospace",
              color: "inherit",
              textDecoration: "none",
              textTransform: "capitalize",
              letterSpacing: "2px",
              border: "2px solid #fff",
              borderRadius: "30px",
              fontWeight: "500",
            }}
            onClick={() => {}}
            href="https://clinicalvisuals.s3.amazonaws.com/medical/liger/pdf/animation_plan_of_iris_final_script_v3.pdf"
            download
          />
        </Box>
      )}
    </header>
  );
};

export default HeaderUtah;
